module.exports = __webpack_public_path__ + "img/Energy Icon.5bcdd633.png";